"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPopulatedInvitations = exports.selectPopulatedSuspendedUsers = exports.selectPopulatedActiveUsers = void 0;
var reselect_1 = require("reselect");
var populated_1 = require("utils/selectors/populated");
var utils_1 = require("utils/selectors/utils");
exports.selectPopulatedActiveUsers = (0, reselect_1.createSelector)(populated_1.selectPopulatedUsersArray, function (users) { return users && users.filter(function (u) { return u.accessLevel && !u.isUnauthUser && !u.isSuspended; }); });
exports.selectPopulatedSuspendedUsers = (0, reselect_1.createSelector)(populated_1.selectPopulatedUsersArray, function (users) { return users && users.filter(function (u) { return u.isSuspended; }); });
exports.selectPopulatedInvitations = ((0, utils_1.makePopulate)('invitations', ['companyTeam']));
